import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FONT_WEIGHTS, SPACINGS } from 'shared/styles/variables';
import styled, { css } from 'styled-components';

import { GovernmentIdClass } from 'lib/constants/governmentIds';
import { CountryCode } from 'lib/constants/locales';
import { VerticalOptionsStyle } from 'lib/interfaces/ThemeSerialized';
import { GovernmentIdEnabledIdClassByCountryEntry } from 'lib/interfaces/verificationConfig';
import OptionVertical from 'verify/components/GovernmentIdOptions/OptionVertical';

const Container = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const OptionBlockPositioner = styled('div')`
  ${({ theme }) =>
    theme.verticalOptionsStyle === VerticalOptionsStyle.Button
      ? css`
          width: 100%;
        `
      : css`
          margin-left: -24px;
          width: calc(100% + 48px);
          margin-right: -24px;
        `};
`;

const NoticeVertical = styled('div')`
  ${({ theme }) =>
    theme.verticalOptionsStyle === VerticalOptionsStyle.Button &&
    css`
      display: none;
    `};
  color: ${({ theme }) => theme.colorFontTitle};
  font-weight: ${FONT_WEIGHTS.medium};
  margin-bottom: ${SPACINGS.base}px;
`;

const OptionsVertical = styled('div')`
  width: 100%;

  flex-direction: column;
  margin-bottom: ${SPACINGS.base * 4}px;
`;

interface GovernmentIdOptionsProps {
  selectedCountryCode: CountryCode;
  enabledIdClassesByCountryEntries: GovernmentIdEnabledIdClassByCountryEntry[];
  handleRouteToSupport: () => void;
  handleSelectType: (type: GovernmentIdClass) => void;
}

export default GovernmentIdOptions as FC<GovernmentIdOptionsProps>;
function GovernmentIdOptions(props: GovernmentIdOptionsProps) {
  const { selectedCountryCode, enabledIdClassesByCountryEntries, handleSelectType } = props;

  const [t] = useTranslation();

  if (enabledIdClassesByCountryEntries && enabledIdClassesByCountryEntries.length > 0) {
    return (
      <Container>
        <NoticeVertical>{t('select.option-notice')}</NoticeVertical>

        <OptionBlockPositioner>
          <OptionsVertical>
            {enabledIdClassesByCountryEntries.map((idClass) => (
              <OptionVertical
                key={idClass.class}
                countryCode={selectedCountryCode}
                /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
                handleSelectType={handleSelectType}
                governmentIdClass={idClass.class}
              />
            ))}
          </OptionsVertical>
        </OptionBlockPositioner>
      </Container>
    );
  } else {
    // TODO: add link to support page
    return (
      <Trans i18nKey='select.unsupported'>
        We are unable to verify identities in this country.{' '}
        <a id='government-id-options__support-link' onClick={props.handleRouteToSupport}>
          Please contact us
        </a>{' '}
        if you don’t have another form of identification.
      </Trans>
    );
  }
}
